export const validateDosageFormat = (dosage: string) => {
  const regexDecimalNumber = /^((\d{0,3})|(\d{1,3}\.\d?))$/
  return regexDecimalNumber.test(dosage)
}
